<div class="layout" [class.collapsed]="collapsed">

  <app-shell-sidebar
    [collapsed]="collapsed"
    [items]="items"
    [openState]="open()"
  (toggleSectionEvent)="toggleSection($event)">
  </app-shell-sidebar>



  <div class="content">
    <app-shell-header [collapsed]="collapsed" (toggleMenu)="toggle()">
    </app-shell-header>

    <app-breadcrumb>
    </app-breadcrumb>

    <main class="page">
      <router-outlet />
    </main>

    <app-footer></app-footer>

  </div>

</div>